// Config/industryTemplates.js
export const INDUSTRY_TEMPLATES = {
  default: {
    components: {
      basic: true,
      category: false,
      pricing: false,
      inventory: false,
      tax: false,
      variants: false,
      medicine: false,
      service: false,
      image: false,
      description: false,
      status: false,
      addItem: false,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false,
      specifications: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "purchase_price",
        "selling_price",
        "mrp"
      ],
      inventory: [
        "sku",
        "stock"
      ]
    },
    variant_fields: {
      required: [],
      optional: []
    },
    table: {
      columns: []
    },
    specifications: [],
  },

  // ==================== CATEGORY 1: E-COMMERCE ====================
  'electronics': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      specifications: true,
      inventory: true,
      tax: true,
      variants: true,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id"
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "purchase_price",
        "mrp",
        "selling_price",
         "discount",
        "discount_type"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
    variant_fields: {
      required: ['sku', 'color_ids', 'price', 'stock'],
      optional: ['barcode', 'model']
    },
    specifications: [
      { key: 'model', label: 'Model', type: 'text' },
      { key: 'serial_number', label: 'Serial Number', type: 'text' },
      { key: 'sku', label: 'SKU', type: 'text' },
      { key: 'barcode', label: 'Barcode', type: 'text' },
      { key: 'warranty', label: 'Warranty', type: 'text' },
      { key: 'color_ids', label: 'Colors', type: 'select', options: 'colors' },
      // { key: 'size_ids', label: 'Sizes', type: 'select', options: 'sizes' },
      { key: 'processor', label: 'Processor', type: 'text' },
      { key: 'ram', label: 'RAM (GB)', type: 'number' },
      { key: 'storage', label: 'Storage (GB)', type: 'number' },
      { key: 'display_size', label: 'Display Size (inches)', type: 'number' },
      { key: 'battery_capacity', label: 'Battery (mAh)', type: 'number' },
      { key: 'operating_system', label: 'OS', type: 'text' },
      { key: 'power_rating', label: 'Power Rating', type: 'text' },
      { key: 'voltage', label: 'Voltage', type: 'text' },
    ],
    table: {
      columns: [
        { key: "product_name", label: "Product Name" },
        { key: "brand_id", label: "Brand" },
        { key: "model", label: "Model" },
        { key: "color_ids", label: "Colors" },
        { key: "warranty", label: "Warranty" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    }
  },
  'grocery': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: true,
      specifications: true,
      tax: true,
      variants: false,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id",
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "mrp",
        "selling_price",
        "purchase_price"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
    specifications: [
      { key: 'sku', label: 'SKU', type: 'text' },
      { key: 'barcode', label: 'Barcode', type: 'text' },
      { key: 'weight', label: 'Weight', type: 'text' },
      { key: 'expiry_date', label: 'Expiry Date', type: 'date' },
      { key: 'dietary_info', label: 'Dietary Info', type: 'text' },
      { key: 'organic', label: 'Organic', type: 'select', options: ['Yes', 'No'] },
    ],
    variant_fields: {
      required: [],
      optional: []
    },
    table: {
      columns: [
        { key: "product_name", label: "Product Name" },
        { key: "brand_id", label: "Brand" },
        { key: "weight", label: "Weight" },
        { key: "expiry_date", label: "Expiry Date", type: "date" },
        { key: "dietary_info", label: "Dietary Info" },
        { key: "organic", label: "Organic" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    }
  },

  'furniture': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: true,
      tax: true,
      variants: true,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false,
      specifications: true
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id"
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "mrp",
        "selling_price",
        "purchase_price"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
    specifications: [
      { key: 'material', label: 'Material', type: 'text' },
      { key: 'color_ids', label: 'Colors', type: 'select', options: 'colors' },
      { key: 'dimensions', label: 'Dimensions', type: 'text' },
      { key: 'weight', label: 'Weight', type: 'text' },
      { key: 'assembly_required', label: 'Assembly Required', type: 'select', options: ['Yes', 'No'] },
      { key: 'warranty', label: 'Warranty', type: 'text' },
      { key: 'sku', label: 'SKU', type: 'text' },
      { key: 'barcode', label: 'Barcode', type: 'text' },
    ],
    variant_fields: {
      required: ['sku', 'color_ids', 'material', 'stock'],
      optional: ['barcode', 'dimensions', 'weight']
    },
    table: {
      columns: [
        { key: "product_name", label: "Product Name" },
        { key: "brand_id", label: "Brand" },
        { key: "material", label: "Material" },
        { key: "color_ids", label: "Colors" },
        { key: "dimensions", label: "Dimensions" },
        { key: "weight", label: "Weight" },
        { key: "assembly_required", label: "Assembly" },
        { key: "warranty", label: "Warranty" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    }
  },

  'beauty': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: true,
      tax: true,
      variants: true,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false,
      specifications: true
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id"
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "mrp",
        "selling_price",
        "purchase_price"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
    specifications: [
      { key: 'sku', label: 'SKU', type: 'text' },
      { key: 'barcode', label: 'Barcode', type: 'text' },
      { key: 'ingredients', label: 'Ingredients', type: 'text' },
      { key: 'expiry_date', label: 'Expiry Date', type: 'date' },
      { key: 'usage', label: 'Usage', type: 'text' },
      { key: 'skin_type', label: 'Skin Type', type: 'text' },
    ],
    variant_fields: {
      required: ['sku', 'price', 'stock'],
      optional: ['barcode', 'expiry', 'skin_type']
    },
    table: {
      columns: [
        { key: "product_name", label: "Product Name" },
        { key: "brand_id", label: "Brand" },
        { key: "sku", label: "SKU" },
        { key: "skin_type", label: "Skin Type" },
        { key: "expiry_date", label: "Expiry Date", type: "date" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    }
  },

  'jewelry': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: true,
      tax: true,
      variants: true,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false,
      specifications: true
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id"
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "mrp",
        "selling_price",
        "purchase_price"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
    specifications: [
      { key: 'material', label: 'Material', type: 'text' },
      { key: 'purity', label: 'Purity', type: 'text' },
      { key: 'weight', label: 'Weight (g)', type: 'number' },
      { key: 'gemstone', label: 'Gemstone', type: 'text' },
      { key: 'warranty', label: 'Warranty', type: 'text' },
      { key: 'certificate', label: 'Certificate', type: 'text' },
      { key: 'sku', label: 'SKU', type: 'text' },
      { key: 'barcode', label: 'Barcode', type: 'text' },
    ],
    variant_fields: {
      required: ['sku', 'material', 'weight', 'price', 'stock'],
      optional: ['barcode', 'purity', 'gemstone', 'certificate']
    },
    table: {
      columns: [
        { key: "product_name", label: "Product Name" },
        { key: "brand_id", label: "Brand" },
        { key: "material", label: "Material" },
        { key: "purity", label: "Purity" },
        { key: "weight", label: "Weight (g)" },
        { key: "gemstone", label: "Gemstone" },
        { key: "certificate", label: "Certificate" },
        { key: "warranty", label: "Warranty" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    }
  },

  'pet-store': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: true,
      specifications: true,

      tax: true,
      variants: false,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id",
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "mrp",
        "selling_price",
        "purchase_price"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
        specifications: [
      { key: 'pet_type', label: 'Pet Type', type: 'text' },
      { key: 'age_group', label: 'Age Group', type: 'text' },
      { key: 'weight', label: 'Weight', type: 'text' },
      { key: 'dietary_info', label: 'Dietary Info', type: 'text' },
      { key: 'ingredients', label: 'Ingredients', type: 'text' },
      { key: 'sku', label: 'SKU', type: 'text' },
      { key: 'barcode', label: 'Barcode', type: 'text' },
    ],
    variant_fields: {
      required: [],
      optional: []
    },
    table: {
        columns: [
        { key: "product_name", label: "Product Name" },
        { key: "brand_id", label: "Brand" },
        { key: "pet_type", label: "Pet Type" },
        { key: "age_group", label: "Age Group" },
        { key: "weight", label: "Weight" },
        { key: "dietary_info", label: "Dietary Info" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    }
  },

  'books': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: true,
      specifications: true,
      tax: true,
      variants: false,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        // "author",
   
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "mrp",
        "selling_price",
        "purchase_price"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
     specifications: [
      { key: 'author', label: 'Author', type: 'text' },
      { key: 'publisher', label: 'Publisher', type: 'text' },
      { key: 'isbn', label: 'ISBN', type: 'text' },
      { key: 'edition', label: 'Edition', type: 'text' },
      { key: 'pages', label: 'Pages', type: 'number' },
      { key: 'language', label: 'Language', type: 'text' },
      { key: 'genre', label: 'Genre', type: 'text' },
      { key: 'sku', label: 'SKU', type: 'text' },
      { key: 'barcode', label: 'Barcode', type: 'text' },
    ],
    variant_fields: {
      required: [],
      optional: []
    },
   table: {
      columns: [
        { key: "product_name", label: "Book Name" },
        { key: "brand_id", label: "Brand" },
        { key: "author", label: "Author" },
        { key: "publisher", label: "Publisher" },
        { key: "genre", label: "Genre" },
        { key: "isbn", label: "ISBN" },
        { key: "edition", label: "Edition" },
        { key: "pages", label: "Pages" },
        { key: "language", label: "Language" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    }
  },

  'toys': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      specifications: true,
      inventory: true,
      tax: true,
      variants: true,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id",
   
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "mrp",
        "selling_price",
        "purchase_price"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
        specifications: [
      { key: 'age_group', label: 'Age Group', type: 'text' },
      { key: 'material', label: 'Material', type: 'text' },
      { key: 'dimensions', label: 'Dimensions', type: 'text' },
      { key: 'battery_required', label: 'Battery Required', type: 'select', options: ['Yes', 'No'] },
      { key: 'safety_certification', label: 'Safety Certification', type: 'text' },
      { key: 'sku', label: 'SKU', type: 'text' },
      { key: 'barcode', label: 'Barcode', type: 'text' },
    ],
    variant_fields: {
      required: ['sku', 'price', 'stock'],
      optional: ['barcode', 'age_group', 'material']
    },
    
    table: {
      columns: [
        { key: "product_name", label: "Product Name" },
        { key: "brand_id", label: "Brand" },
        { key: "age_group", label: "Age Group" },
        { key: "material", label: "Material" },
        { key: "dimensions", label: "Dimensions" },
        { key: "battery_required", label: "Battery" },
        { key: "safety_certification", label: "Safety Cert." },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    }
  },

  'sports': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: true,
      tax: true,
      variants: true,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false,
      specifications: true
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id"
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "mrp",
        "selling_price",
        "purchase_price"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
    specifications: [
      { key: 'size_ids', label: 'Sizes', type: 'select', options: 'sizes' },
      { key: 'material', label: 'Material', type: 'text' },
      { key: 'weight', label: 'Weight', type: 'text' },
      { key: 'sport_type', label: 'Sport Type', type: 'text' },
      { key: 'skill_level', label: 'Skill Level', type: 'text' },
      { key: 'sku', label: 'SKU', type: 'text' },
      { key: 'barcode', label: 'Barcode', type: 'text' },
    ],
    variant_fields: {
      required: ['sku', 'size_ids', 'price', 'stock'],
      optional: ['barcode', 'material', 'weight']
    },
    table: {
      columns: [
        { key: "product_name", label: "Product Name" },
        { key: "brand_id", label: "Brand" },
        { key: "sport_type", label: "Sport Type" },
        { key: "skill_level", label: "Skill Level" },
        { key: "size_ids", label: "Sizes" },
        { key: "material", label: "Material" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    }
  },
  'automotive-parts': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: true,
      specifications: true,
      tax: true,
      variants: true,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id",
        ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "mrp",
        "selling_price",
        "purchase_price"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
      specifications: [
      { key: 'model', label: 'Model', type: 'text' },
      { key: 'year', label: 'Year', type: 'text' },
      { key: 'part_number', label: 'Part Number', type: 'text' },
      { key: 'vehicle_type', label: 'Vehicle Type', type: 'text' },
      { key: 'compatibility', label: 'Compatibility', type: 'text' },
      { key: 'warranty', label: 'Warranty', type: 'text' },
      { key: 'sku', label: 'SKU', type: 'text' },
      { key: 'barcode', label: 'Barcode', type: 'text' },
    ],
    variant_fields: {
      required: ['sku', 'price', 'stock'],
      optional: ['barcode', 'part_number', 'year']
    },
    table: {
      columns: [
        { key: "product_name", label: "Part Name" },
        { key: "brand_id", label: "Brand" },
        { key: "vehicle_type", label: "Vehicle Type" },
        { key: "model", label: "Model" },
        { key: "year", label: "Year" },
        { key: "part_number", label: "Part No." },
        { key: "compatibility", label: "Compatibility" },
        { key: "warranty", label: "Warranty" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    }
  },

  // ==================== CATEGORY 2: RETAIL ====================
  'clothing-store': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: true,
      specifications: true,
      tax: true,
      variants: true,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id",
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "purchase_price",
        "mrp",
        "selling_price",
         "discount",,
        "discount_type"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
        specifications: [
      { key: 'sku', label: 'SKU', type: 'text' },
      { key: 'barcode', label: 'Barcode', type: 'text' },
      { key: 'color_ids', label: 'Colors', type: 'select', options: 'colors' },
      { key: 'size_ids', label: 'Sizes', type: 'select', options: 'sizes' },
      { key: 'material', label: 'Material', type: 'text' },
      { key: 'fit', label: 'Fit', type: 'select', options: ['Slim', 'Regular', 'Loose'] },
      { key: 'fabric_type', label: 'Fabric Type', type: 'text' },
      { key: 'pattern', label: 'Pattern', type: 'text' },
      { key: 'gender', label: 'Gender', type: 'select', options: ['Men', 'Women', 'Unisex'] },
      { key: 'season', label: 'Season', type: 'select', options: ['Summer', 'Winter', 'All'] },
      { key: 'collection', label: 'Collection', type: 'text' },
      { key: 'occasion', label: 'Occasion', type: 'text' },
      { key: 'neck_type', label: 'Neck Type', type: 'text' },
      { key: 'sleeve_type', label: 'Sleeve Type', type: 'text' },
      { key: 'closure_type', label: 'Closure Type', type: 'text' },
      { key: 'manufacturer', label: 'Manufacturer', type: 'text' },
      { key: 'country_of_origin', label: 'Country of Origin', type: 'text' },
    ],
    variant_fields: {
      required: ['sku', 'color_ids', 'size_ids', 'stock', 'price'],
      optional: ['barcode', 'material', 'fit', 'pattern']
    },
    table: {
      columns: [
        { key: "product_name", label: "Product Name" },
        { key: "brand_id", label: "Brand" },
        { key: "color_ids", label: "Colors" },
        { key: "size_ids", label: "Sizes" },
        { key: "material", label: "Material" },
        { key: "gender", label: "Gender" },
        { key: "season", label: "Season" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    }
  },

  'fashion': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: true,
      tax: true,
      variants: true,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: true,
      property: false,
      specifications: true
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id"
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],

      pricing: [
        "mrp",
        "selling_price",
        "purchase_price",
        //  "discount",,
        "discount_type"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "stock",
        "min_stock_level",
        "reorder_level"
      ]
    },
    specifications: [
      { key: 'sku', label: 'SKU', type: 'text' },
      { key: 'barcode', label: 'Barcode', type: 'text' },
      { key: 'fabric_type', label: 'Fabric Type', type: 'text' },
      { key: 'style', label: 'Style', type: 'text' },
      { key: 'color_ids', label: 'Colors', type: 'select', options: 'colors' },
      { key: 'size_ids', label: 'Sizes', type: 'select', options: 'sizes' },
      { key: 'material', label: 'Material', type: 'text' },
      { key: 'fit', label: 'Fit', type: 'select', options: ['Slim', 'Regular', 'Loose'] },
      { key: 'pattern', label: 'Pattern', type: 'text' },
      { key: 'gender', label: 'Gender', type: 'select', options: ['Men', 'Women', 'Unisex'] },
      { key: 'season', label: 'Season', type: 'select', options: ['Summer', 'Winter', 'All'] },
      { key: 'collection', label: 'Collection', type: 'text' },
      { key: 'occasion', label: 'Occasion', type: 'text' },
      { key: 'sleeve_type', label: 'Sleeve Type', type: 'text' },
      { key: 'neck_type', label: 'Neck Type', type: 'text' },
      { key: 'closure_type', label: 'Closure Type', type: 'text' },
      { key: 'country_of_origin', label: 'Country of Origin', type: 'text' },
      { key: 'manufacturer', label: 'Manufacturer', type: 'text' },
    ],
    variant_fields: {
      required: ['sku', 'color_ids', 'size_ids', 'stock', 'price'],
      optional: ['barcode', 'material', 'fit', 'pattern', 'style', 'weight', 'image']
    },
    table: {
      columns: [
        { key: "product_name", label: "Product" },
        { key: "brand_id", label: "Brand" },
        { key: "sku", label: "SKU" },
        { key: "color_ids", label: "Color" },
        { key: "size_ids", label: "Size" },
        { key: "material", label: "Material" },
        { key: "fit", label: "Fit" },
        { key: "gender", label: "Gender" },
        { key: "season", label: "Season" },
        { key: "selling_price", label: "Price", type: "price" },
        { key: "stock", label: "Stock" },
        { key: "status", label: "Status" }
      ]
    }
  },

  'mobile-store': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      variants: true,
      specifications: true,
      inventory: true,
      image: true,
      description: true,
      status: true,
      addItem: true,
      tax: true,
      medicine: false,
      service: false,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false,

    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id",
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "purchase_price",
        "selling_price",
        "mrp"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
    variant_fields: {
      required: ['sku', 'color_ids', 'ram', 'storage', 'stock', 'price'],
      optional: ['barcode', 'imei', 'warranty', 'model']
    },
    table: {
      columns: [
        { key: "product_name", label: "Product" },
        { key: "brand_id", label: "Brand" },
        { key: "model", label: "Model" },
        { key: "ram", label: "RAM" },
        { key: "storage", label: "Storage" },
        { key: "color_ids", label: "Color" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    },
    specifications: [
      { key: 'model', label: 'Model', type: 'text' },
      { key: 'ram', label: 'RAM (GB)', type: 'number' },
      { key: 'sku', label: 'SKU', type: 'text' },
      { key: 'storage', label: 'Storage (GB)', type: 'number' },
      { key: 'barcode', label: 'Barcode', type: 'text' },
      { key: 'color_ids', label: 'Colors', type: 'select', options: 'colors' },
      { key: 'imei', label: 'IMEI', type: 'text' },
      { key: 'processor', label: 'Processor', type: 'text' },
      { key: 'serial_number', label: 'Serial Number', type: 'text' },
      { key: 'display_size', label: 'Display Size (inches)', type: 'number' },
      { key: 'battery_capacity', label: 'Battery (mAh)', type: 'number' },
      { key: 'camera', label: 'Camera (MP)', type: 'text' },
      { key: 'operating_system', label: 'OS', type: 'text' },
      { key: 'warranty', label: 'Warranty', type: 'text' },
      { key: 'manufacturer', label: 'Manufacturer', type: 'text' },
      { key: 'country_of_origin', label: 'Country of Origin', type: 'text' },
    ],
  },

  'supermarket': {
    components: {
      basic: true,
      category: true,
      pricing: true,
       specifications: true,
      inventory: true,
      tax: true,
      variants: true,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
       "brand_id"
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "purchase_price",
        "selling_price",
        "mrp"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
        specifications: [
      { key: 'category', label: 'Category', type: 'text' },
      { key: 'subcategory', label: 'Subcategory', type: 'text' },
      { key: 'sku', label: 'SKU', type: 'text' },
      { key: 'barcode', label: 'Barcode', type: 'text' },
      { key: 'weight', label: 'Weight', type: 'text' },
      { key: 'expiry_date', label: 'Expiry Date', type: 'date' },
      { key: 'batch_number', label: 'Batch Number', type: 'text' },
      { key: 'dietary_info', label: 'Dietary Info', type: 'text' },
    ],
    variant_fields: {
      required: ['sku', 'weight', 'stock', 'price'],
      optional: ['barcode', 'batch', 'expiry', 'dietary_info']
    },
     table: {
      columns: [
        { key: "product_name", label: "Product Name" },
        { key: "brand_id", label: "Brand" },
        { key: "weight", label: "Weight" },
        { key: "dietary_info", label: "Dietary Info" },
        { key: "batch_number", label: "Batch No." },
        { key: "expiry_date", label: "Expiry Date", type: "date" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    }
  },

  'pharmacy': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      specifications: true,
      inventory: true,
      tax: true,
      variants: false,
      medicine: true,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
      "brand_id"
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "purchase_price",
        "selling_price",
        "mrp"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
     specifications: [
      { key: 'sku', label: 'SKU', type: 'text' },
      { key: 'barcode', label: 'Barcode', type: 'text' },
      { key: 'batch_number', label: 'Batch Number', type: 'text' },
      { key: 'expiry_date', label: 'Expiry Date', type: 'date' },
      { key: 'generic_name', label: 'Generic Name', type: 'text' },
      { key: 'dosage', label: 'Dosage', type: 'text' },
      { key: 'composition', label: 'Composition', type: 'text' },
      { key: 'schedule', label: 'Schedule', type: 'select', options: ['H', 'X', 'G'] },
      { key: 'manufacturer', label: 'Manufacturer', type: 'text' },
    ],
    variant_fields: {
      required: [],
      optional: []
    },
    table: {
      columns: [
        { key: "product_name", label: "Product Name" },
        { key: "brand_id", label: "Brand" },
        { key: "generic_name", label: "Generic Name" },
        { key: "dosage", label: "Dosage" },
        { key: "composition", label: "Composition" },
        { key: "manufacturer", label: "Manufacturer" },
        { key: "schedule", label: "Schedule" },
        { key: "batch_number", label: "Batch No." },
        { key: "expiry_date", label: "Expiry Date", type: "date" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    },
   
  },

  'gift-shop': {
    components: {
      basic: true,
      category: true,
      pricing: true,
         specifications: true ,
      inventory: true,
      tax: true,
      variants: false,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id",
        
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "mrp",
        "selling_price",
        "purchase_price"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
      specifications: [
    { key: 'occasion', label: 'Occasion', type: 'text' },
    { key: 'material', label: 'Material', type: 'text' },
    { key: 'weight', label: 'Weight', type: 'text' },
    { key: 'dimensions', label: 'Dimensions', type: 'text' },
    { key: 'gift_type', label: 'Gift Type', type: 'text' },
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
  ],
    variant_fields: {
      required: [],
      optional: []
    },
    table: {
      columns: [
        { key: "product_name", label: "Gift Name" },
        { key: "brand_id", label: "Brand" },
        { key: "occasion", label: "Occasion" },
        { key: "gift_type", label: "Gift Type" },
        { key: "material", label: "Material" },
        { key: "dimensions", label: "Dimensions" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    }
  },

  'stationery': {
    components: {
      basic: true,
      category: true,
      pricing: true,
       specifications: true  ,
      inventory: true,
      tax: true,
      variants: false,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id",
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "mrp",
        "selling_price",
        "purchase_price"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
      specifications: [  
    { key: 'material', label: 'Material', type: 'text' },
    { key: 'color_ids', label: 'Colors', type: 'select', options: 'colors' },
    { key: 'size_ids', label: 'Sizes', type: 'select', options: 'sizes' },
    { key: 'quantity_per_pack', label: 'Quantity Per Pack', type: 'number' },
    { key: 'usage', label: 'Usage', type: 'text' },
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
  ],
    variant_fields: {
      required: [],
      optional: []
    },
    table: {
      columns: [
        { key: "product_name", label: "Product Name" },
        { key: "brand_id", label: "Brand" },
        { key: "material", label: "Material" },
        { key: "color_ids", label: "Color" },
        { key: "size_ids", label: "size_ids" },
        { key: "quantity_per_pack", label: "Per Pack" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    }
  },

  'shoe-store': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: true,
          specifications: true,
      tax: true,
      variants: true,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id",
              ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "mrp",
        "selling_price",
        "purchase_price"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
      specifications: [  // ✅ BAAKI SARI FIELDS YAHAN
    { key: 'size_ids', label: 'Sizes', type: 'select', options: 'sizes' },
    { key: 'material', label: 'Material', type: 'text' },
    { key: 'color_ids', label: 'Colors', type: 'select', options: 'colors' },
    { key: 'gender', label: 'Gender', type: 'select', options: ['Men', 'Women', 'Unisex'] },
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
  ],
    variant_fields: {
      required: ['sku', 'color_ids', 'size_ids', 'stock', 'price'],
      optional: ['barcode', 'material']
    },
    table: {
      columns: [
        { key: "product_name", label: "Product Name" },
        { key: "brand_id", label: "Brand" },
        { key: "color_ids", label: "Colors" },
        { key: "size_ids", label: "size_idss" },
        { key: "material", label: "Material" },
        { key: "gender", label: "Gender" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    }
  },

  // ==================== CATEGORY 3: MANUFACTURING ====================
  'textile': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: true,
      tax: true,
      variants: true,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,         // <--- ✅ Inventory Add Button ke liye enable kiya
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false,
      specifications: true   // <--- ✅ Specifications enable kiya
    },
    fields: {
      basic: [
        "user_id",
        "product_name"
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "mrp",
        "selling_price",
        "purchase_price"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
    variant_fields: {
      required: ['sku', 'color_ids', 'size_ids', 'stock', 'price'],
      optional: ['barcode', 'material', 'weight']
    },
    // ✅ Specifications Array (Textile ke specific fields)
    specifications: [
      { key: 'material', label: 'Material', type: 'select', options: ['Cotton', 'Polyester', 'Wool', 'Silk', 'Nylon', 'Linen'] },
      { key: 'color_ids', label: 'Colors', type: 'select', options: 'colors' },
      { key: 'size_ids', label: 'Sizes', type: 'select', options: 'sizes' },
      { key: 'weight', label: 'Weight (kg)', type: 'number' },
      { key: 'quality_grade', label: 'Quality Grade', type: 'select', options: ['A', 'B', 'C', 'Premium'] },
      { key: 'fabric_type', label: 'Fabric Type', type: 'select', options: ['Woven', 'Knitted', 'Non-woven', 'Technical'] },
      { key: 'pattern', label: 'Pattern', type: 'text' },
    ],
    // ✅ Inventory Table Config (Inventory Items ko Table mein dikhane ke liye)
    inventory_table: [
      { key: "sku", label: "SKU" },
      { key: "stock", label: "Stock" },
      { key: "unit_id", label: "Unit" },
      { key: "min_stock_level", label: "Min Stock" },
      { key: "reorder_level", label: "Reorder" }
    ],
    table: {
      columns: [
        { key: "product_name", label: "Product Name" },
        { key: "material", label: "Material" }, // Ye sahi hai
        { key: "color_ids", label: "Colors" },  // ✅ 'color_ids' rahega, label 'Colors'
        { key: "size_ids", label: "Sizes" },    // ✅ 'size_ids' rahega, label 'Sizes'
        { key: "weight", label: "Weight" },
        { key: "quality_grade", label: "Grade" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    }
  },

  'food-processing': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: true,
      tax: true,
      variants: false,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false,
      specifications: true,
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id",
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "mrp",
        "selling_price",
        "purchase_price"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },

    variant_fields: {
      required: [],
      optional: []
    },
          specifications: [ 
    { key: 'weight', label: 'Weight', type: 'text' },
    { key: 'expiry_date', label: 'Expiry', type: 'date' },
    { key: 'dietary_info', label: 'Dietary Info', type: 'text' },
    { key: 'organic', label: 'Organic', type: 'select', options: ['Yes', 'No'] },
    { key: 'certifications', label: 'Certifications', type: 'text' },
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
  ],
    table: {
      columns: [
        { key: "product_name", label: "Product Name" },
        { key: "brand_id", label: "Brand" },
        { key: "weight", label: "Weight" },
        { key: "expiry_date", label: "Expiry", type: "date" },
        { key: "dietary_info", label: "Dietary Info" },
        { key: "organic", label: "Organic" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    }
  },

  'chemicals': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: true,
      specifications: true,
      tax: true,
      variants: false,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",

      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "mrp",
        "selling_price",
        "purchase_price"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
    variant_fields: {
      required: [],
      optional: []
    },
    specifications: [
      { key: 'chemical_formula', label: 'Chemical Formula', type: 'text' },
      { key: 'purity', label: 'Purity (%)', type: 'text' },
      { key: 'grade', label: 'Grade', type: 'select', options: ['Analytical', 'Industrial', 'Technical', 'Reagent'] },
      { key: 'hazards', label: 'Hazards', type: 'text' },
      { key: 'storage_conditions', label: 'Storage Conditions', type: 'text' },
      { key: 'sku', label: 'SKU', type: 'text' },
      { key: 'barcode', label: 'Barcode', type: 'text' },
    ],
    table: {
      columns: [
        { key: "product_name", label: "Product Name" },
        { key: "chemical_formula", label: "Formula" },
        { key: "purity", label: "Purity" },
        { key: "grade", label: "Grade" },
        { key: "hazards", label: "Hazards" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    }
  },

  'machinery': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: true,
      tax: true,
      variants: true,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
        specifications: true ,
      property: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id",

      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "mrp",
        "selling_price",
        "purchase_price"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
    variant_fields: {
      required: ['sku', 'model', 'price', 'stock'],
      optional: ['barcode', 'power', 'warranty']
    },
      specifications: [  
    { key: 'power', label: 'Power (HP/kW)', type: 'number', required: true },
    { key: 'weight', label: 'Weight (kg)', type: 'number', required: false },
    { key: 'dimensions', label: 'Dimensions (LxWxH)', type: 'text', required: false },
    { key: 'warranty', label: 'Warranty (months)', type: 'number', required: false },
    { key: 'specifications', label: 'Detailed Specs', type: 'textarea', required: false },
  ],
    table: {
      columns: [
        { key: "product_name", label: "Product Name" },
        { key: "brand_id", label: "Brand" },
        { key: "model", label: "Model" },
        { key: "specifications", label: "Specs" },
        { key: "power", label: "Power" },
        { key: "warranty", label: "Warranty" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    },
 
  },

'plastic': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: true,
    medicine: false,
    service: false,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id" 
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "mrp",
      "selling_price",
      "purchase_price"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ]
  },
  specifications: [  
    { key: 'material_type', label: 'Material Type', type: 'text' },
    { key: 'color_ids', label: 'Colors', type: 'select', options: 'colors' },
    { key: 'thickness', label: 'Thickness', type: 'number' },
    { key: 'weight', label: 'Weight', type: 'text' },
    { key: 'size_ids', label: 'Sizes', type: 'select', options: 'sizes' },
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
  ],
  variant_fields: {
    required: ['sku', 'color_ids', 'size_ids', 'stock', 'price'],
    optional: ['barcode', 'material_type', 'thickness']
  },
  table: {
    columns: [
      { key: "product_name", label: "Product Name" },
      { key: "brand_id", label: "Brand" },
      { key: "material_type", label: "Material Type" },
      { key: "color_ids", label: "Colors" },
      { key: "size_ids", label: "Sizes" },
      { key: "thickness", label: "Thickness" },
      { key: "weight", label: "Weight" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" },
      { key: "stock", label: "Stock" }
    ]
  }
},

'metal-fabrication': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: true,
    medicine: false,
    service: false,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ SIRF YEH 3 FIELDS
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "mrp",
      "selling_price",
      "purchase_price"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ]
  },
  specifications: [  // ✅ BAAKI SARI FIELDS YAHAN
    { key: 'material', label: 'Material', type: 'text' },
    { key: 'finish', label: 'Finish', type: 'text' },
    { key: 'thickness', label: 'Thickness', type: 'number' },
    { key: 'weight', label: 'Weight', type: 'text' },
    { key: 'dimensions', label: 'Dimensions', type: 'text' },
    { key: 'grade', label: 'Grade', type: 'text' },
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
  ],
  variant_fields: {
    required: ['sku', 'material', 'stock', 'price'],
    optional: ['barcode', 'finish', 'grade', 'thickness']
  },
  table: {
    columns: [
      { key: "product_name", label: "Product Name" },
      { key: "brand_id", label: "Brand" },
      { key: "material", label: "Material" },
      { key: "grade", label: "Grade" },
      { key: "finish", label: "Finish" },
      { key: "thickness", label: "Thickness" },
      { key: "dimensions", label: "Dimensions" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" },
      { key: "stock", label: "Stock" }
    ]
  }
},

  'electronics-manufacturing': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: true,
      tax: true,
      variants: true,
      medicine: false,
      service: false,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id",
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "mrp",
        "selling_price",
        "purchase_price"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ]
    },
    variant_fields: {
      required: ['sku', 'model', 'price', 'stock'],
      optional: ['barcode', 'warranty', 'certifications']
    },
    table: {
      columns: [
        { key: "product_name", label: "Product Name" },
        { key: "brand_id", label: "Brand" },
        { key: "model", label: "Model" },
        { key: "specifications", label: "Specs" },
        { key: "warranty", label: "Warranty" },
        { key: "compliance", label: "Compliance" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    },
    specifications: [
      { key: 'specifications', label: 'Technical Specs', type: 'textarea', required: true },
      { key: 'warranty', label: 'Warranty (months)', type: 'number', required: false },
      { key: 'compliance', label: 'Compliance Standards', type: 'text', required: false },
      { key: 'certifications', label: 'Certifications', type: 'text', required: false },
    ]
  },

  // ==================== CATEGORY 4: INFORMATION TECHNOLOGY ====================
'software-company': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: true,
    subscription: true,
    property: false,
    specifications: true  // ✅ ALREADY CORRECT
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id, REMOVE others
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "selling_price",
      "mrp",
      "renewal_price"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [
      "service_type",
      "service_duration",
      "start_date",
      "end_date"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'software_code', label: 'Software Code', type: 'text' },
    { key: 'license_type', label: 'License Type', type: 'select', options: ['Perpetual', 'Subscription', 'OEM'] },
    { key: 'subscription_plan', label: 'Subscription Plan', type: 'select', options: ['Basic', 'Pro', 'Enterprise'] },
    { key: 'user_limit', label: 'User Limit', type: 'number' },
    { key: 'cloud_hosted', label: 'Cloud Hosted', type: 'select', options: ['Yes', 'No'] },
    { key: 'version', label: 'Version', type: 'text' },
    { key: 'platform', label: 'Platform', type: 'select', options: ['Web', 'Desktop', 'Mobile'] },
    { key: 'deployment_type', label: 'Deployment', type: 'select', options: ['Cloud', 'On-Premise', 'Hybrid'] },
    { key: 'support_email', label: 'Support Email', type: 'email' },
    { key: 'support_phone', label: 'Support Phone', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Software Name" },
      { key: "brand_id", label: "Brand" },
      { key: "service_type", label: "Service Type" },
      { key: "license_type", label: "License Type" },
      { key: "subscription_plan", label: "Plan" },
      { key: "user_limit", label: "User Limit" },
      { key: "platform", label: "Platform" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

  'saas': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: false,
      tax: true,
      variants: false,
      medicine: false,
      service: true,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: true,
      subscription: true,
      property: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
      ],
        category: [
      "category_id",
      "subcategory_id"
    ],
      pricing: [
        "selling_price",
        "mrp"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      service: [
        "service_duration"
      ]
    },
    variant_fields: {
      required: [],
      optional: []
    },
    table: {
      columns: [
        { key: 'product_name', label: 'SaaS Name' },
        { key: 'subscription_plan', label: 'Plan' },
        { key: 'user_limit', label: 'User Limit' },
        { key: 'storage_limit', label: 'Storage Limit' },
        { key: 'monthly_fee', label: 'Monthly Fee', type: 'price' },
        { key: 'annual_fee', label: 'Annual Fee', type: 'price' },
        { key: 'mrp', label: 'MRP', type: 'price' },
        { key: 'selling_price', label: 'Selling Price', type: 'price' }
      ]
    },
    specifications: [
      { key: 'subscription_plan', label: 'Plan', type: 'select', options: ['Basic', 'Pro', 'Enterprise'], required: true },
      { key: 'user_limit', label: 'User Limit', type: 'number', required: false },
      { key: 'storage_limit', label: 'Storage Limit (GB)', type: 'number', required: false },
      { key: 'api_limits', label: 'API Limits (req/day)', type: 'number', required: false },
      { key: 'features', label: 'Features', type: 'textarea', required: false },
    ]
  },

 'web-development': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: true,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'project_type', label: 'Project Type', type: 'text' },
    { key: 'technology_stack', label: 'Technology Stack', type: 'text' },
    { key: 'timeline', label: 'Timeline', type: 'text' },
    { key: 'revisions', label: 'Revisions', type: 'number' },
    { key: 'hosting_included', label: 'Hosting Included', type: 'select', options: ['Yes', 'No'] },
    { key: 'pages_count', label: 'Pages Count', type: 'number' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Project Name" },
      { key: "brand_id", label: "Brand" },
      { key: "project_type", label: "Project Type" },
      { key: "technology_stack", label: "Tech Stack" },
      { key: "pages_count", label: "Pages" },
      { key: "timeline", label: "Timeline" },
      { key: "revisions", label: "Revisions" },
      { key: "hosting_included", label: "Hosting" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

'mobile-app-development': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: true,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'platform', label: 'Platform', type: 'select', options: ['iOS', 'Android', 'Both'] },
    { key: 'app_type', label: 'App Type', type: 'text' },
    { key: 'features', label: 'Features', type: 'textarea' },
    { key: 'timeline', label: 'Timeline', type: 'text' },
    { key: 'revisions', label: 'Revisions', type: 'number' },
    { key: 'maintenance', label: 'Maintenance', type: 'select', options: ['Yes', 'No'] },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "App Name" },
      { key: "brand_id", label: "Brand" },
      { key: "platform", label: "Platform" },
      { key: "app_type", label: "App Type" },
      { key: "features", label: "Features" },
      { key: "timeline", label: "Timeline" },
      { key: "revisions", label: "Revisions" },
      { key: "maintenance", label: "Maintenance" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

'ai-company': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: true,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'model_type', label: 'Model Type', type: 'text' },
    { key: 'accuracy', label: 'Accuracy (%)', type: 'number' },
    { key: 'training_data', label: 'Training Data', type: 'text' },
    { key: 'deployment', label: 'Deployment', type: 'select', options: ['Cloud', 'On-Premise', 'Edge'] },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "service_type", label: "Type" },
      { key: "model_type", label: "Model" },
      { key: "accuracy", label: "Accuracy" },
      { key: "deployment", label: "Deployment" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

'cybersecurity': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: true,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",  // ✅ ADD user_id
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'coverage', label: 'Coverage', type: 'text' },
    { key: 'compliance', label: 'Compliance', type: 'text' },
    { key: 'response_time', label: 'Response Time', type: 'text' },
    { key: 'monitoring', label: 'Monitoring', type: 'select', options: ['24/7', 'Business Hours'] },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "service_type", label: "Type" },
      { key: "coverage", label: "Coverage" },
      { key: "compliance", label: "Compliance" },
      { key: "response_time", label: "Response Time" },
      { key: "monitoring", label: "Monitoring" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

'it-services': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: true,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'infrastructure', label: 'Infrastructure', type: 'text' },
    { key: 'support_level', label: 'Support Level', type: 'select', options: ['Basic', 'Standard', 'Premium'] },
    { key: 'response_time', label: 'Response Time', type: 'text' },
    { key: 'sla', label: 'SLA', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "service_type", label: "Type" },
      { key: "support_level", label: "Support" },
      { key: "response_time", label: "Response" },
      { key: "sla", label: "SLA" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

  // ==================== CATEGORY 5: HEALTHCARE ====================
 'hospital': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: false,
    medicine: true,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: true,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "appointment_fee",
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
    { key: 'batch', label: 'Batch Number', type: 'text' },
    { key: 'expiry', label: 'Expiry Date', type: 'date' },
    { key: 'generic_name', label: 'Generic Name', type: 'text' },
    { key: 'dosage', label: 'Dosage', type: 'text' },
    { key: 'doctor_name', label: 'Doctor Name', type: 'text' },
    { key: 'specialization', label: 'Specialization', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: 'product_name', label: 'Product/Service' },
      { key: 'brand_id', label: 'Brand' },
      { key: 'generic_name', label: 'Generic Name' },
      { key: 'dosage', label: 'Dosage' },
      { key: 'doctor_name', label: 'Doctor' },
      { key: 'specialization', label: 'Specialization' },
      { key: 'service_type', label: 'Service Type' },
      { key: 'batch_number', label: 'Batch No.' },
      { key: 'expiry_date', label: 'Expiry Date', type: 'date' },
      { key: 'appointment_fee', label: 'Appointment Fee', type: 'price' },
      { key: 'mrp', label: 'MRP', type: 'price' },
      { key: 'selling_price', label: 'Selling Price', type: 'price' },
      { key: 'stock', label: 'Stock' }
    ]
  }
},

 'clinic': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: false,
    medicine: true,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: true,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id" 
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ],
    service: [ 
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
    { key: 'batch', label: 'Batch Number', type: 'text' },
    { key: 'expiry', label: 'Expiry Date', type: 'date' },
    { key: 'doctor_name', label: 'Doctor Name', type: 'text' },
    { key: 'specialization', label: 'Specialization', type: 'text' },
    { key: 'consultation_type', label: 'Consultation Type', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: 'product_name', label: 'Product/Service' },
      { key: 'brand_id', label: 'Brand' },
      { key: 'doctor_name', label: 'Doctor' },
      { key: 'specialization', label: 'Specialization' },
      { key: 'consultation_type', label: 'Consultation Type' },
      { key: 'service_type', label: 'Service Type' },
      { key: 'batch_number', label: 'Batch No.' },
      { key: 'expiry_date', label: 'Expiry Date', type: 'date' },
      { key: 'mrp', label: 'MRP', type: 'price' },
      { key: 'selling_price', label: 'Selling Price', type: 'price' },
      { key: 'stock', label: 'Stock' }
    ]
  }
},

 'dental-clinic': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: false,
    medicine: true,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: true,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ],
    service: [  
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
    { key: 'batch', label: 'Batch Number', type: 'text' },
    { key: 'expiry', label: 'Expiry Date', type: 'date' },
    { key: 'dentist_name', label: 'Dentist Name', type: 'text' },
    { key: 'procedure_type', label: 'Procedure Type', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: 'product_name', label: 'Product/Service' },
      { key: 'brand_id', label: 'Brand' },
      { key: 'dentist_name', label: 'Dentist' },
      { key: 'procedure_type', label: 'Procedure' },
      { key: 'service_type', label: 'Service Type' },
      { key: 'batch_number', label: 'Batch No.' },
      { key: 'expiry_date', label: 'Expiry Date', type: 'date' },
      { key: 'mrp', label: 'MRP', type: 'price' },
      { key: 'selling_price', label: 'Selling Price', type: 'price' },
      { key: 'stock', label: 'Stock' }
    ]
  }
},

'laboratory': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: true,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  
    ],
    category: [
      "category_id",
      "subcategory_id"  
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  
    { key: 'test_name', label: 'Test Name', type: 'text' },
    { key: 'results_time', label: 'Results Time', type: 'text' },
    { key: 'sample_type', label: 'Sample Type', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Test Name" },
      { key: "brand_id", label: "Brand" },
      { key: "test_name", label: "Test" },
      { key: "service_type", label: "Type" },
      { key: "sample_type", label: "Sample" },
      { key: "results_time", label: "Results Time" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

'physiotherapy': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: true,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  
    ],
    category: [
      "category_id",
      "subcategory_id"  
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  
    { key: 'therapist_name', label: 'Therapist Name', type: 'text' },
    { key: 'treatment_type', label: 'Treatment Type', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "treatment_type", label: "Treatment" },
      { key: "therapist_name", label: "Therapist" },
      { key: "service_duration", label: "Duration" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

'veterinary': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: false,
    medicine: true,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: true,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id" 
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ],
    service: [ 
      "service_type",
      "service_duration"
    ]
  },
  specifications: [ 
    { key: 'animal_type', label: 'Animal Type', type: 'text' },
    { key: 'vet_name', label: 'Vet Name', type: 'text' },
    { key: 'specialization', label: 'Specialization', type: 'text' },
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
    { key: 'batch', label: 'Batch Number', type: 'text' },
    { key: 'expiry', label: 'Expiry Date', type: 'date' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Product/Service" },
      { key: "brand_id", label: "Brand" },
      { key: "animal_type", label: "Animal Type" },
      { key: "vet_name", label: "Vet" },
      { key: "specialization", label: "Specialization" },
      { key: "service_type", label: "Service Type" },
      { key: "batch_number", label: "Batch No." },
      { key: "expiry_date", label: "Expiry Date", type: "date" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" },
      { key: "stock", label: "Stock" }
    ]
  }
},

  // ==================== CATEGORY 6: EDUCATION ====================

'school': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: false,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'board', label: 'Board', type: 'text' },
    { key: 'medium', label: 'Medium', type: 'text' },
    { key: 'session', label: 'Session', type: 'text' },
    { key: 'class_name', label: 'Class Name', type: 'text' },
    { key: 'grade_level', label: 'Grade Level', type: 'text' },
    { key: 'subject', label: 'Subject', type: 'text' },
    { key: 'duration', label: 'Duration', type: 'text' },
    { key: 'schedule', label: 'Schedule', type: 'text' },
    { key: 'capacity', label: 'Capacity', type: 'number' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: 'product_name', label: 'Course/Subject' },
      { key: 'brand_id', label: 'Brand' },
      { key: 'board', label: 'Board' },
      { key: 'medium', label: 'Medium' },
      { key: 'class_name', label: 'Class' },
      { key: 'grade_level', label: 'Grade' },
      { key: 'duration', label: 'Duration' },
      { key: 'schedule', label: 'Schedule' },
      { key: 'capacity', label: 'Capacity' },
      { key: 'mrp', label: 'Fee', type: 'price' },
      { key: 'selling_price', label: 'Selling Price', type: 'price' }
    ]
  }
},
'college': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: false,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'course_name', label: 'Course Name', type: 'text' },
    { key: 'degree', label: 'Degree', type: 'text' },
    { key: 'semester', label: 'Semester', type: 'text' },
    { key: 'department', label: 'Department', type: 'text' },
    { key: 'duration', label: 'Duration', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Course Name" },
      { key: "brand_id", label: "Brand" },
      { key: "degree", label: "Degree" },
      { key: "semester", label: "Semester" },
      { key: "department", label: "Department" },
      { key: "duration", label: "Duration" },
      { key: "mrp", label: "Fee", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

'university': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: false,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'course_name', label: 'Course Name', type: 'text' },
    { key: 'degree', label: 'Degree', type: 'text' },
    { key: 'department', label: 'Department', type: 'text' },
    { key: 'faculty', label: 'Faculty', type: 'text' },
    { key: 'duration', label: 'Duration', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Course Name" },
      { key: "brand_id", label: "Brand" },
      { key: "degree", label: "Degree" },
      { key: "faculty", label: "Faculty" },
      { key: "department", label: "Department" },
      { key: "duration", label: "Duration" },
      { key: "mrp", label: "Fee", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},
'coaching-center': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: false,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'course_name', label: 'Course Name', type: 'text' },
    { key: 'board', label: 'Board', type: 'text' },
    { key: 'medium', label: 'Medium', type: 'text' },
    { key: 'batch_timing', label: 'Batch Timing', type: 'text' },
    { key: 'duration', label: 'Duration', type: 'text' },
    { key: 'syllabus', label: 'Syllabus', type: 'text' },
    { key: 'exam_prep', label: 'Exam Prep', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Course Name" },
      { key: "brand_id", label: "Brand" },
      { key: "board", label: "Board" },
      { key: "medium", label: "Medium" },
      { key: "batch_timing", label: "Batch Timing" },
      { key: "duration", label: "Duration" },
      { key: "exam_prep", label: "Exam Prep" },
      { key: "mrp", label: "Fee", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

'online-learning': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: false,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: true,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'course_name', label: 'Course Name', type: 'text' },
    { key: 'platform', label: 'Platform', type: 'text' },
    { key: 'modules', label: 'Modules', type: 'number' },
    { key: 'certification', label: 'Certification', type: 'select', options: ['Yes', 'No'] },
    { key: 'access_duration', label: 'Access Duration', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Course Name" },
      { key: "brand_id", label: "Brand" },
      { key: "platform", label: "Platform" },
      { key: "modules", label: "Modules" },
      { key: "certification", label: "Certification" },
      { key: "access_duration", label: "Access Duration" },
      { key: "mrp", label: "Fee", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

'training-institute': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: false,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'course_name', label: 'Course Name', type: 'text' },
    { key: 'batch_timing', label: 'Batch Timing', type: 'text' },
    { key: 'duration', label: 'Duration', type: 'text' },
    { key: 'syllabus', label: 'Syllabus', type: 'text' },
    { key: 'certification', label: 'Certification', type: 'select', options: ['Yes', 'No'] },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Course Name" },
      { key: "brand_id", label: "Brand" },
      { key: "batch_timing", label: "Batch Timing" },
      { key: "duration", label: "Duration" },
      { key: "syllabus", label: "Syllabus" },
      { key: "certification", label: "Certification" },
      { key: "mrp", label: "Fee", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

  // ==================== CATEGORY 7: REAL ESTATE ====================


 'residential': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: false,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: true,
    specifications: true  // ✅ ALREADY CORRECT
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ]
  },
  specifications: [  // ✅ ALREADY CORRECT
    { key: 'property_type', label: 'Property Type', type: 'select', options: ['Apartment', 'Villa', 'Studio', 'Penthouse'] },
    { key: 'property_size', label: 'Size (sq.ft)', type: 'number' },
    { key: 'carpet_area', label: 'Carpet Area (sq.ft)', type: 'number' },
    { key: 'bedrooms', label: 'BHK', type: 'number' },
    { key: 'bathrooms', label: 'Bathrooms', type: 'number' },
    { key: 'floor', label: 'Floor Number', type: 'number' },
    { key: 'furnished', label: 'Furnished', type: 'select', options: ['Fully', 'Semi', 'Unfurnished'] },
    { key: 'parking', label: 'Parking', type: 'select', options: ['None', '1', '2', '3+'] },
    { key: 'amenities', label: 'Amenities', type: 'textarea' },
    { key: 'locality', label: 'Locality', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: 'product_name', label: 'Property Name' },
      { key: 'brand_id', label: 'Brand' },
      { key: 'property_type', label: 'Type' },
      { key: 'property_size', label: 'Size (sq.ft)' },
      { key: 'carpet_area', label: 'Carpet Area' },
      { key: 'bedrooms', label: 'BHK' },
      { key: 'bathrooms', label: 'Bathrooms' },
      { key: 'floor', label: 'Floor' },
      { key: 'furnished', label: 'Furnished' },
      { key: 'locality', label: 'Locality' },
      { key: 'mrp', label: 'Price', type: 'price' },
      { key: 'selling_price', label: 'Selling Price', type: 'price' }
    ]
  }
},

 'commercial': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: false,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: true,
    specifications: true  // ✅ ALREADY CORRECT
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ]
  },
  specifications: [  // ✅ ALREADY CORRECT
    { key: 'property_type', label: 'Property Type', type: 'select', options: ['Commercial', 'Office', 'Retail', 'Industrial'] },
    { key: 'property_size_ids', label: 'Size (sq.ft)', type: 'number' },
    { key: 'floor', label: 'Floor Number', type: 'number' },
    { key: 'zoned_for', label: 'Zoned For', type: 'text' },
    { key: 'parking', label: 'Parking', type: 'select', options: ['None', '1', '2', '3+'] },
    { key: 'amenities', label: 'Amenities', type: 'textarea' },
    { key: 'lease_terms', label: 'Lease Terms', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: 'product_name', label: 'Property Name' },
      { key: 'brand_id', label: 'Brand' },
      { key: 'property_type', label: 'Type' },
      { key: 'property_size_ids', label: 'Size (sq.ft)' },
      { key: 'floor', label: 'Floor' },
      { key: 'zoned_for', label: 'Zoned For' },
      { key: 'lease_terms', label: 'Lease Terms' },
      { key: 'locality', label: 'Locality' },
      { key: 'mrp', label: 'Price', type: 'price' },
      { key: 'selling_price', label: 'Selling Price', type: 'price' }
    ]
  }
},

 'property-dealer': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: true,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'property_type', label: 'Property Type', type: 'select', options: ['Apartment', 'Villa', 'Commercial', 'Plot'] },
    { key: 'locality', label: 'Locality', type: 'text' },
    { key: 'budget_range', label: 'Budget Range', type: 'text' },
    { key: 'deal_type', label: 'Deal Type', type: 'select', options: ['Sale', 'Rent', 'Lease'] },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Property Name" },
      { key: "brand_id", label: "Brand" },
      { key: "property_type", label: "Type" },
      { key: "locality", label: "Locality" },
      { key: "budget_range", label: "Budget Range" },
      { key: "deal_type", label: "Deal Type" },
      { key: "mrp", label: "Price", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

'builder': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: false,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: true,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'project_name', label: 'Project Name', type: 'text' },
    { key: 'project_type', label: 'Project Type', type: 'select', options: ['Residential', 'Commercial', 'Mixed Use'] },
    { key: 'units_available', label: 'Units Available', type: 'number' },
    { key: 'possession', label: 'Possession', type: 'text' },
    { key: 'locality', label: 'Locality', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Project Name" },
      { key: "brand_id", label: "Brand" },
      { key: "project_type", label: "Type" },
      { key: "units_available", label: "Units Available" },
      { key: "possession", label: "Possession" },
      { key: "locality", label: "Locality" },
      { key: "mrp", label: "Price", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

  // ==================== CATEGORY 8: CONSTRUCTION ====================

  
 'contractor': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'project_type', label: 'Project Type', type: 'text' },
    { key: 'duration', label: 'Duration', type: 'text' },
    { key: 'team_size_ids', label: 'Team Size', type: 'number' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: 'product_name', label: 'Service Name' },
      { key: 'brand_id', label: 'Brand' },
      { key: 'service_type', label: 'Type' },
      { key: 'project_type', label: 'Project Type' },
      { key: 'duration', label: 'Duration' },
      { key: 'team_size_ids', label: 'Team Size' },
      { key: 'mrp', label: 'MRP', type: 'price' },
      { key: 'selling_price', label: 'Selling Price', type: 'price' }
    ]
  }
},

 'civil-engineering': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'project_type', label: 'Project Type', type: 'text' },
    { key: 'duration', label: 'Duration', type: 'text' },
    { key: 'specializations', label: 'Specializations', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "service_type", label: "Type" },
      { key: "project_type", label: "Project Type" },
      { key: "duration", label: "Duration" },
      { key: "specializations", label: "Specializations" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

 'architecture': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'project_type', label: 'Project Type', type: 'text' },
    { key: 'style', label: 'Style', type: 'text' },
    { key: 'duration', label: 'Duration', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "service_type", label: "Type" },
      { key: "project_type", label: "Project Type" },
      { key: "style", label: "Style" },
      { key: "duration", label: "Duration" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

'plumbing': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'emergency', label: 'Emergency Service', type: 'select', options: ['Yes', 'No'] },
    { key: 'certifications', label: 'Certifications', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "service_type", label: "Type" },
      { key: "emergency", label: "Emergency" },
      { key: "certifications", label: "Certifications" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

'electrical-services': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'emergency', label: 'Emergency Service', type: 'select', options: ['Yes', 'No'] },
    { key: 'certifications', label: 'Certifications', type: 'text' },
    { key: 'voltage', label: 'Voltage', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "service_type", label: "Type" },
      { key: "emergency", label: "Emergency" },
      { key: "certifications", label: "Certifications" },
      { key: "voltage", label: "Voltage" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

  // ==================== CATEGORY 9: FINANCE ====================

'accounting': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'accounting_standard', label: 'Accounting Standard', type: 'text' },
    { key: 'software', label: 'Software', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: 'product_name', label: 'Service Name' },
      { key: 'brand_id', label: 'Brand' },
      { key: 'service_type', label: 'Type' },
      { key: 'accounting_standard', label: 'Standard' },
      { key: 'software', label: 'Software' },
      { key: 'mrp', label: 'MRP', type: 'price' },
      { key: 'selling_price', label: 'Selling Price', type: 'price' }
    ]
  }
},

 'tax-consultant': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'tax_type', label: 'Tax Type', type: 'text' },
    { key: 'filing_type', label: 'Filing Type', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "service_type", label: "Type" },
      { key: "tax_type", label: "Tax Type" },
      { key: "filing_type", label: "Filing Type" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

'insurance': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'insurance_type', label: 'Insurance Type', type: 'text' },
    { key: 'coverage', label: 'Coverage', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "insurance_type", label: "Insurance Type" },
      { key: "coverage", label: "Coverage" },
      { key: "service_type", label: "Type" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

 'investment': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'investment_type', label: 'Investment Type', type: 'text' },
    { key: 'risk_level', label: 'Risk Level', type: 'select', options: ['Low', 'Medium', 'High'] },
    { key: 'returns', label: 'Returns', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "investment_type", label: "Investment Type" },
      { key: "risk_level", label: "Risk Level" },
      { key: "returns", label: "Returns" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

 'banking': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true 
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  
    ],
    category: [
      "category_id",
      "subcategory_id"  
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [ 
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  
    { key: 'account_type', label: 'Account Type', type: 'text' },
    { key: 'interest_rate', label: 'Interest Rate', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "service_type", label: "Type" },
      { key: "account_type", label: "Account Type" },
      { key: "interest_rate", label: "Interest Rate" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},



  // ==================== CATEGORY 10: HOSPITALITY ====================

 'restaurant': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: true,
    medicine: false,
    service: false,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: true,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
    { key: 'cuisine_type', label: 'Cuisine Type', type: 'text' },
    { key: 'dietary_info', label: 'Dietary Info', type: 'text' },
    { key: 'spice_level', label: 'Spice Level', type: 'select', options: ['Mild', 'Medium', 'Hot', 'Extra Hot'] },
    { key: 'prep_time', label: 'Preparation Time', type: 'text' },
    { key: 'serving_size_ids', label: 'Serving Size', type: 'text' },
    { key: 'allergens', label: 'Allergens', type: 'text' },
    { key: 'ingredients', label: 'Ingredients', type: 'textarea' },
  ],
  variant_fields: {
    required: ['sku', 'size_ids', 'price', 'stock'],
    optional: ['spice_level', 'dietary_info', 'serving_size_ids']
  },
  table: {
    columns: [
      { key: 'product_name', label: 'Item Name' },
      { key: 'brand_id', label: 'Brand' },
      { key: 'cuisine_type', label: 'Cuisine' },
      { key: 'dietary_info', label: 'Dietary Info' },
      { key: 'spice_level', label: 'Spice Level' },
      { key: 'prep_time', label: 'Prep Time' },
      { key: 'serving_size_ids', label: 'Serving Size' },
      { key: 'allergens', label: 'Allergens' },
      { key: 'mrp', label: 'MRP', type: 'price' },
      { key: 'selling_price', label: 'Selling Price', type: 'price' },
      { key: 'stock', label: 'Stock' }
    ]
  }
},

 'hotel': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: true,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ALREADY CORRECT
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ ALREADY CORRECT
    { key: 'room_type', label: 'Room Type', type: 'select', options: ['Standard', 'Deluxe', 'Suite'] },
    { key: 'bed_type', label: 'Bed Type', type: 'select', options: ['Single', 'Double', 'King', 'Queen'] },
    { key: 'occupancy', label: 'Occupancy', type: 'number' },
    { key: 'view', label: 'View', type: 'select', options: ['City', 'Sea', 'Mountain', 'Pool'] },
    { key: 'wifi', label: 'WiFi', type: 'select', options: ['Free', 'Paid', 'Not Available'] },
    { key: 'breakfast', label: 'Breakfast', type: 'select', options: ['Included', 'Extra Charge'] },
    { key: 'amenities', label: 'Amenities', type: 'textarea' },
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
  ],
  variant_fields: {
    required: ['sku', 'room_type', 'price', 'stock'],
    optional: ['bed_type', 'occupancy', 'view', 'wifi', 'breakfast']
  },
  table: {
    columns: [
      { key: 'product_name', label: 'Room/Service' },
      { key: 'brand_id', label: 'Brand' },
      { key: 'room_type', label: 'Room Type' },
      { key: 'bed_type', label: 'Bed Type' },
      { key: 'occupancy', label: 'Occupancy' },
      { key: 'view', label: 'View' },
      { key: 'floor', label: 'Floor' },
      { key: 'wifi', label: 'WiFi' },
      { key: 'breakfast', label: 'Breakfast' },
      { key: 'mrp', label: 'MRP', type: 'price' },
      { key: 'selling_price', label: 'Selling Price', type: 'price' },
      { key: 'stock', label: 'Stock' }
    ]
  }
},

  'cafe': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: true,
    medicine: false,
    service: false,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: true,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
    { key: 'cuisine_type', label: 'Cuisine Type', type: 'text' },
    { key: 'dietary_info', label: 'Dietary Info', type: 'text' },
    { key: 'spice_level', label: 'Spice Level', type: 'select', options: ['Mild', 'Medium', 'Hot', 'Extra Hot'] },
    { key: 'prep_time', label: 'Preparation Time', type: 'text' },
    { key: 'serving_size_ids', label: 'Serving Size', type: 'text' },
    { key: 'beverages', label: 'Beverages', type: 'text' },
  ],
  variant_fields: {
    required: ['sku', 'size_ids', 'price', 'stock'],
    optional: ['spice_level', 'dietary_info', 'serving_size_ids']
  },
  table: {
    columns: [
      { key: "product_name", label: "Item Name" },
      { key: "brand_id", label: "Brand" },
      { key: "cuisine_type", label: "Cuisine" },
      { key: "dietary_info", label: "Dietary Info" },
      { key: "beverages", label: "Beverages" },
      { key: "prep_time", label: "Prep Time" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" },
      { key: "stock", label: "Stock" }
    ]
  }
},

 'resort': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: true,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
    { key: 'room_type', label: 'Room Type', type: 'select', options: ['Standard', 'Deluxe', 'Suite', 'Villa'] },
    { key: 'bed_type', label: 'Bed Type', type: 'select', options: ['Single', 'Double', 'King', 'Queen'] },
    { key: 'occupancy', label: 'Occupancy', type: 'number' },
    { key: 'view', label: 'View', type: 'select', options: ['City', 'Sea', 'Mountain', 'Pool', 'Garden'] },
    { key: 'amenities', label: 'Amenities', type: 'textarea' },
    { key: 'activities', label: 'Activities', type: 'text' },
  ],
  variant_fields: {
    required: ['sku', 'room_type', 'price', 'stock'],
    optional: ['bed_type', 'occupancy', 'view', 'activities']
  },
  table: {
    columns: [
      { key: "product_name", label: "Room/Service" },
      { key: "brand_id", label: "Brand" },
      { key: "room_type", label: "Room Type" },
      { key: "bed_type", label: "Bed Type" },
      { key: "occupancy", label: "Occupancy" },
      { key: "view", label: "View" },
      { key: "activities", label: "Activities" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" },
      { key: "stock", label: "Stock" }
    ]
  }
},

 'bakery': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: true,
    medicine: false,
    service: false,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: true,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
    { key: 'dietary_info', label: 'Dietary Info', type: 'text' },
    { key: 'allergens', label: 'Allergens', type: 'text' },
    { key: 'ingredients', label: 'Ingredients', type: 'textarea' },
    { key: 'weight', label: 'Weight', type: 'text' },
  ],
  variant_fields: {
    required: ['sku', 'weight', 'price', 'stock'],
    optional: ['barcode', 'dietary_info', 'allergens']
  },
  table: {
    columns: [
      { key: "product_name", label: "Item Name" },
      { key: "brand_id", label: "Brand" },
      { key: "dietary_info", label: "Dietary Info" },
      { key: "allergens", label: "Allergens" },
      { key: "weight", label: "Weight" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" },
      { key: "stock", label: "Stock" }
    ]
  }
},

 'catering': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: true,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
    { key: 'cuisine_type', label: 'Cuisine Type', type: 'text' },
    { key: 'dietary_info', label: 'Dietary Info', type: 'text' },
    { key: 'serving_size_ids', label: 'Serving Size', type: 'text' },
    { key: 'event_type', label: 'Event Type', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "cuisine_type", label: "Cuisine" },
      { key: "dietary_info", label: "Dietary Info" },
      { key: "serving_size_ids", label: "Serving Size" },
      { key: "event_type", label: "Event Type" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" },
      { key: "stock", label: "Stock" }
    ]
  }
},

  // ==================== CATEGORY 11: LOGISTICS ====================
 'courier': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'delivery_type', label: 'Delivery Type', type: 'text' },
    { key: 'weight_limit', label: 'Weight Limit', type: 'text' },
    { key: 'dimensions', label: 'Dimensions', type: 'text' },
    { key: 'service_area', label: 'Service Area', type: 'text' },
    { key: 'delivery_time', label: 'Delivery Time', type: 'text' },
    { key: 'tracking', label: 'Tracking', type: 'select', options: ['Yes', 'No'] },
    { key: 'insurance', label: 'Insurance', type: 'select', options: ['Yes', 'No'] },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: 'product_name', label: 'Service Name' },
      { key: 'brand_id', label: 'Brand' },
      { key: 'delivery_type', label: 'Delivery Type' },
      { key: 'weight_limit', label: 'Weight Limit' },
      { key: 'dimensions', label: 'Dimensions' },
      { key: 'service_area', label: 'Service Area' },
      { key: 'delivery_time', label: 'Delivery Time' },
      { key: 'tracking', label: 'Tracking' },
      { key: 'insurance', label: 'Insurance' },
      { key: 'mrp', label: 'MRP', type: 'price' },
      { key: 'selling_price', label: 'Selling Price', type: 'price' }
    ]
  }
},

 'freight': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'freight_type', label: 'Freight Type', type: 'text' },
    { key: 'weight_limit', label: 'Weight Limit', type: 'text' },
    { key: 'dimensions', label: 'Dimensions', type: 'text' },
    { key: 'route', label: 'Route', type: 'text' },
    { key: 'transit_time', label: 'Transit Time', type: 'text' },
    { key: 'insurance', label: 'Insurance', type: 'select', options: ['Yes', 'No'] },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "freight_type", label: "Type" },
      { key: "weight_limit", label: "Weight Limit" },
      { key: "route", label: "Route" },
      { key: "transit_time", label: "Transit Time" },
      { key: "insurance", label: "Insurance" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

 'warehousing': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'warehouse_type', label: 'Warehouse Type', type: 'text' },
    { key: 'storage_capacity', label: 'Storage Capacity', type: 'text' },
    { key: 'temperature_controlled', label: 'Temperature Controlled', type: 'select', options: ['Yes', 'No'] },
    { key: 'security', label: 'Security', type: 'text' },
    { key: 'location', label: 'Location', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "warehouse_type", label: "Type" },
      { key: "storage_capacity", label: "Capacity" },
      { key: "temperature_controlled", label: "Temp Control" },
      { key: "security", label: "Security" },
      { key: "location", label: "Location" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

 'transport': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'transport_type', label: 'Transport Type', type: 'text' },
    { key: 'vehicle_type', label: 'Vehicle Type', type: 'text' },
    { key: 'capacity', label: 'Capacity', type: 'text' },
    { key: 'route', label: 'Route', type: 'text' },
    { key: 'tracking', label: 'Tracking', type: 'select', options: ['Yes', 'No'] },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "transport_type", label: "Type" },
      { key: "vehicle_type", label: "Vehicle" },
      { key: "capacity", label: "Capacity" },
      { key: "route", label: "Route" },
      { key: "tracking", label: "Tracking" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

 'movers-packers': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'distance', label: 'Distance', type: 'text' },
    { key: 'items_included', label: 'Items Included', type: 'textarea' },
    { key: 'packing_materials', label: 'Packing Materials', type: 'text' },
    { key: 'insurance', label: 'Insurance', type: 'select', options: ['Yes', 'No'] },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "service_type", label: "Type" },
      { key: "distance", label: "Distance" },
      { key: "items_included", label: "Items Included" },
      { key: "packing_materials", label: "Packing" },
      { key: "insurance", label: "Insurance" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

  // ==================== CATEGORY 12: AUTOMOTIVE ====================
 'car-dealer': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: true,
    medicine: false,
    service: false,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'model', label: 'Model', type: 'text' },
    { key: 'year', label: 'Year', type: 'text' },
    { key: 'mileage', label: 'Mileage', type: 'text' },
    { key: 'engine_type', label: 'Engine Type', type: 'text' },
    { key: 'transmission', label: 'Transmission', type: 'select', options: ['Automatic', 'Manual'] },
    { key: 'fuel_type', label: 'Fuel Type', type: 'select', options: ['Petrol', 'Diesel', 'Electric', 'Hybrid'] },
    { key: 'warranty', label: 'Warranty', type: 'text' },
    { key: 'color_ids', label: 'Colors', type: 'select', options: 'colors' },
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
  ],
  variant_fields: {
    required: ['sku', 'color_ids', 'engine_type', 'price', 'stock'],
    optional: ['barcode', 'transmission', 'fuel_type', 'warranty', 'year', 'mileage']
  },
  table: {
    columns: [
      { key: 'product_name', label: 'Vehicle Name' },
      { key: 'brand_id', label: 'Brand' },
      { key: 'model', label: 'Model' },
      { key: 'year', label: 'Year' },
      { key: 'mileage', label: 'Mileage' },
      { key: 'engine_type', label: 'Engine' },
      { key: 'transmission', label: 'Transmission' },
      { key: 'fuel_type', label: 'Fuel Type' },
      { key: 'color_ids', label: 'Colors' },
      { key: 'warranty', label: 'Warranty' },
      { key: 'mrp', label: 'MRP', type: 'price' },
      { key: 'selling_price', label: 'Selling Price', type: 'price' },
      { key: 'stock', label: 'Stock' }
    ]
  }
},

 'bike-dealer': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: true,
    medicine: false,
    service: false,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'model', label: 'Model', type: 'text' },
    { key: 'engine_cc', label: 'Engine CC', type: 'text' },
    { key: 'mileage', label: 'Mileage', type: 'text' },
    { key: 'transmission', label: 'Transmission', type: 'select', options: ['Automatic', 'Manual'] },
    { key: 'fuel_type', label: 'Fuel Type', type: 'select', options: ['Petrol', 'Electric'] },
    { key: 'warranty', label: 'Warranty', type: 'text' },
    { key: 'color_ids', label: 'Colors', type: 'select', options: 'colors' },
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
  ],
  variant_fields: {
    required: ['sku', 'color_ids', 'engine_cc', 'price', 'stock'],
    optional: ['barcode', 'transmission', 'fuel_type', 'warranty']
  },
  table: {
    columns: [
      { key: "product_name", label: "Vehicle Name" },
      { key: "brand_id", label: "Brand" },
      { key: "model", label: "Model" },
      { key: "engine_cc", label: "Engine CC" },
      { key: "mileage", label: "Mileage" },
      { key: "transmission", label: "Transmission" },
      { key: "fuel_type", label: "Fuel Type" },
      { key: "color_ids", label: "Colors" },
      { key: "warranty", label: "Warranty" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" },
      { key: "stock", label: "Stock" }
    ]
  }
},

 'repair-garage': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'vehicle_type', label: 'Vehicle Type', type: 'text' },
    { key: 'warranty', label: 'Warranty', type: 'text' },
    { key: 'certifications', label: 'Certifications', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "service_type", label: "Type" },
      { key: "vehicle_type", label: "Vehicle Type" },
      { key: "warranty", label: "Warranty" },
      { key: "certifications", label: "Certifications" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

'car-rental': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'car_type', label: 'Car Type', type: 'text' },
    { key: 'rental_duration', label: 'Rental Duration', type: 'text' },
    { key: 'insurance', label: 'Insurance', type: 'select', options: ['Yes', 'No'] },
    { key: 'fuel_policy', label: 'Fuel Policy', type: 'text' },
    { key: 'mileage_limit', label: 'Mileage Limit', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Vehicle Name" },
      { key: "brand_id", label: "Brand" },
      { key: "car_type", label: "Car Type" },
      { key: "rental_duration", label: "Rental Duration" },
      { key: "insurance", label: "Insurance" },
      { key: "fuel_policy", label: "Fuel Policy" },
      { key: "mileage_limit", label: "Mileage Limit" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

 'spare-parts': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: true,
    medicine: false,
    service: false,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'model', label: 'Model', type: 'text' },
    { key: 'part_number', label: 'Part Number', type: 'text' },
    { key: 'compatibility', label: 'Compatibility', type: 'text' },
    { key: 'warranty', label: 'Warranty', type: 'text' },
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
  ],
  variant_fields: {
    required: ['sku', 'brand_id', 'model', 'price', 'stock'],
    optional: ['barcode', 'part_number', 'warranty']
  },
  table: {
    columns: [
      { key: "product_name", label: "Part Name" },
      { key: "brand_id", label: "Brand" },
      { key: "model", label: "Model" },
      { key: "part_number", label: "Part No." },
      { key: "compatibility", label: "Compatibility" },
      { key: "warranty", label: "Warranty" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" },
      { key: "stock", label: "Stock" }
    ]
  }
},

  // ==================== CATEGORY 13: BEAUTY & WELLNESS ====================
'salon': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    appointment: true,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
    { key: 'staff_name', label: 'Staff Name', type: 'text' },
    { key: 'skill_level', label: 'Skill Level', type: 'text' },
    { key: 'brand_id_used', label: 'Brand Used', type: 'text' },
    { key: 'aftercare', label: 'Aftercare', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: 'product_name', label: 'Service Name' },
      { key: 'brand_id', label: 'Brand' },
      { key: 'service_type', label: 'Service Type' },
      { key: 'service_duration', label: 'Duration' },
      { key: 'staff_name', label: 'Staff' },
      { key: 'skill_level', label: 'Skill Level' },
      { key: 'brand_id_used', label: 'Brand Used' },
      { key: 'mrp', label: 'MRP', type: 'price' },
      { key: 'selling_price', label: 'Selling Price', type: 'price' },
      { key: 'stock', label: 'Stock' }
    ]
  }
},

 'spa': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    appointment: true,
    inventory: true,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'staff_name', label: 'Staff Name', type: 'text' },
    { key: 'skill_level', label: 'Skill Level', type: 'text' },
    { key: 'brand_id_used', label: 'Brand Used', type: 'text' },
    { key: 'facilities', label: 'Facilities', type: 'textarea' },
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "service_type", label: "Type" },
      { key: "service_duration", label: "Duration" },
      { key: "staff_name", label: "Staff" },
      { key: "facilities", label: "Facilities" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" },
      { key: "stock", label: "Stock" }
    ]
  }
},

'gym': {
  components: {
    basic: true,
    category: true,
    appointment: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'membership_type', label: 'Membership Type', type: 'text' },
    { key: 'duration', label: 'Duration', type: 'text' },
    { key: 'trainer', label: 'Trainer', type: 'text' },
    { key: 'facilities', label: 'Facilities', type: 'textarea' },
    { key: 'schedule', label: 'Schedule', type: 'text' },
    { key: 'age_group', label: 'Age Group', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Membership" },
      { key: "brand_id", label: "Brand" },
      { key: "membership_type", label: "Type" },
      { key: "duration", label: "Duration" },
      { key: "trainer", label: "Trainer" },
      { key: "facilities", label: "Facilities" },
      { key: "schedule", label: "Schedule" },
      { key: "age_group", label: "Age Group" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

'yoga-studio': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    appointment: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'class_type', label: 'Class Type', type: 'text' },
    { key: 'duration', label: 'Duration', type: 'text' },
    { key: 'instructor', label: 'Instructor', type: 'text' },
    { key: 'level', label: 'Level', type: 'select', options: ['Beginner', 'Intermediate', 'Advanced'] },
    { key: 'schedule', label: 'Schedule', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Class Name" },
      { key: "brand_id", label: "Brand" },
      { key: "class_type", label: "Type" },
      { key: "duration", label: "Duration" },
      { key: "instructor", label: "Instructor" },
      { key: "level", label: "Level" },
      { key: "schedule", label: "Schedule" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

'cosmetics': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    appointment: true,
    inventory: true,
    tax: true,
    variants: false,
    medicine: false,
    service: false,
    image: true,
    description: true,
    status: true,
    addItem: true,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'skin_type', label: 'Skin Type', type: 'text' },
    { key: 'ingredients', label: 'Ingredients', type: 'text' },
    { key: 'expiry_date', label: 'Expiry Date', type: 'date' },
    { key: 'usage', label: 'Usage', type: 'text' },
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Product Name" },
      { key: "brand_id", label: "Brand" },
      { key: "skin_type", label: "Skin Type" },
      { key: "expiry_date", label: "Expiry", type: "date" },
      { key: "usage", label: "Usage" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" },
      { key: "stock", label: "Stock" }
    ]
  }
},

  // ==================== CATEGORY 14: AGRICULTURE ====================
 'farming': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: true,
    medicine: false,
    service: false,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ALREADY CORRECT
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ]
  },
  specifications: [  // ✅ ALREADY CORRECT
    { key: 'crop_type', label: 'Crop Type', type: 'text' },
    { key: 'variety', label: 'Variety', type: 'text' },
    { key: 'season', label: 'Season', type: 'select', options: ['Kharif', 'Rabi', 'Zaid'] },
    { key: 'yield', label: 'Yield (kg/acre)', type: 'number' },
    { key: 'quality_grade', label: 'Quality Grade', type: 'select', options: ['A', 'B', 'C'] },
    { key: 'organic', label: 'Organic', type: 'select', options: ['Yes', 'No'] },
    { key: 'region', label: 'Region', type: 'text' },
    { key: 'harvest_date', label: 'Harvest Date', type: 'date' },
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
  ],
  variant_fields: {
    required: ['sku', 'crop_type', 'variety', 'price', 'stock'],
    optional: ['barcode', 'season', 'yield', 'quality_grade', 'organic', 'region', 'harvest_date']
  },
  table: {
    columns: [
      { key: 'product_name', label: 'Crop Name' },
      { key: 'brand_id', label: 'Brand' },
      { key: 'crop_type', label: 'Crop Type' },
      { key: 'variety', label: 'Variety' },
      { key: 'season', label: 'Season' },
      { key: 'yield', label: 'Yield' },
      { key: 'quality_grade', label: 'Quality Grade' },
      { key: 'organic', label: 'Organic' },
      { key: 'region', label: 'Region' },
      { key: 'harvest_date', label: 'Harvest Date', type: 'date' },
      { key: 'mrp', label: 'MRP', type: 'price' },
      { key: 'selling_price', label: 'Selling Price', type: 'price' },
      { key: 'stock', label: 'Stock' }
    ]
  }
},

  'dairy': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: false,
    medicine: false,
    service: false,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'product_type', label: 'Product Type', type: 'text' },
    { key: 'fat_content', label: 'Fat %', type: 'text' },
    { key: 'pasteurized', label: 'Pasteurized', type: 'select', options: ['Yes', 'No'] },
    { key: 'shelf_life', label: 'Shelf Life', type: 'text' },
    { key: 'organic', label: 'Organic', type: 'select', options: ['Yes', 'No'] },
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Product Name" },
      { key: "brand_id", label: "Brand" },
      { key: "product_type", label: "Type" },
      { key: "fat_content", label: "Fat %" },
      { key: "pasteurized", label: "Pasteurized" },
      { key: "shelf_life", label: "Shelf Life" },
      { key: "organic", label: "Organic" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" },
      { key: "stock", label: "Stock" }
    ]
  }
},

 'poultry': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: false,
    medicine: false,
    service: false,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'bird_type', label: 'Bird Type', type: 'text' },
    { key: 'age_group', label: 'Age Group', type: 'text' },
    { key: 'feed_type', label: 'Feed Type', type: 'text' },
    { key: 'organic', label: 'Organic', type: 'select', options: ['Yes', 'No'] },
    { key: 'certifications', label: 'Certifications', type: 'text' },
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Product Name" },
      { key: "brand_id", label: "Brand" },
      { key: "bird_type", label: "Bird Type" },
      { key: "age_group", label: "Age Group" },
      { key: "feed_type", label: "Feed Type" },
      { key: "organic", label: "Organic" },
      { key: "certifications", label: "Certifications" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" },
      { key: "stock", label: "Stock" }
    ]
  }
},

 'seeds': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: false,
    medicine: false,
    service: false,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'crop_type', label: 'Crop Type', type: 'text' },
    { key: 'variety', label: 'Variety', type: 'text' },
    { key: 'germination_rate', label: 'Germination %', type: 'number' },
    { key: 'purity', label: 'Purity', type: 'text' },
    { key: 'organic', label: 'Organic', type: 'select', options: ['Yes', 'No'] },
    { key: 'season', label: 'Season', type: 'text' },
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Seed Name" },
      { key: "brand_id", label: "Brand" },
      { key: "crop_type", label: "Crop Type" },
      { key: "variety", label: "Variety" },
      { key: "germination_rate", label: "Germination %" },
      { key: "purity", label: "Purity" },
      { key: "organic", label: "Organic" },
      { key: "season", label: "Season" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" },
      { key: "stock", label: "Stock" }
    ]
  }
},

 'fertilizers': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: false,
    medicine: false,
    service: false,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'fertilizer_type', label: 'Fertilizer Type', type: 'text' },
    { key: 'nutrients', label: 'Nutrients', type: 'text' },
    { key: 'application_method', label: 'Application Method', type: 'text' },
    { key: 'organic', label: 'Organic', type: 'select', options: ['Yes', 'No'] },
    { key: 'certifications', label: 'Certifications', type: 'text' },
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Product Name" },
      { key: "brand_id", label: "Brand" },
      { key: "fertilizer_type", label: "Type" },
      { key: "nutrients", label: "Nutrients" },
      { key: "application_method", label: "Application" },
      { key: "organic", label: "Organic" },
      { key: "certifications", label: "Certifications" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" },
      { key: "stock", label: "Stock" }
    ]
  }
},

 'agricultural-equipment': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: true,
    tax: true,
    variants: true,
    medicine: false,
    service: false,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "purchase_price",
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    inventory: [
      "unit_id",
      "min_stock_level",
      "reorder_level"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'equipment_type', label: 'Equipment Type', type: 'text' },
    { key: 'model', label: 'Model', type: 'text' },
    { key: 'specifications', label: 'Specifications', type: 'textarea' },
    { key: 'warranty', label: 'Warranty', type: 'text' },
    { key: 'sku', label: 'SKU', type: 'text' },
    { key: 'barcode', label: 'Barcode', type: 'text' },
  ],
  variant_fields: {
    required: ['sku', 'brand_id', 'model', 'price', 'stock'],
    optional: ['barcode', 'specifications', 'warranty']
  },
  table: {
    columns: [
      { key: "product_name", label: "Equipment Name" },
      { key: "brand_id", label: "Brand" },
      { key: "model", label: "Model" },
      { key: "equipment_type", label: "Type" },
      { key: "specifications", label: "Specs" },
      { key: "warranty", label: "Warranty" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" },
      { key: "stock", label: "Stock" }
    ]
  }
},

  // ==================== CATEGORY 15: TRAVEL ====================
  // 'travel-agency': {
  //   components: {
  //     basic: true,
  //     category: true,
  //     pricing: true,
  //     inventory: false,
  //     tax: true,
  //     variants: true,
  //     medicine: false,
  //     service: true,
  //     image: true,
  //     description: true,
  //     status: true,
  //     addItem: true,
  //     appointment: false,
  //     food: false,
  //     digital: false,
  //     subscription: false,
  //     property: false
  //   },
  //   fields: {
  //     basic: [
  //       "user_id",
  //       "product_name",
  //       "sku",
  //       "destination",
  //       "duration",
  //       "package_type",
  //       "accommodation",
  //       "meals",
  //       "transport",
  //       "activities",
  //       "guide",
  //       "service_duration",
  //       "service_type"
  //     ],
  //     pricing: [
  //       "selling_price",
  //       "mrp"
  //     ],
  //     tax: [
  //       "gst_percentage",
  //       "hsn_code"
  //     ]
  //   },
  //   variant_fields: {
  //     required: ['sku', 'destination', 'duration', 'price'],
  //     optional: ['package_type', 'accommodation', 'meals', 'transport', 'guide']
  //   },
  //   table: {
  //     columns: [
  //       { key: 'product_name', label: 'Package Name' },
  //       { key: 'destination', label: 'Destination' },
  //       { key: 'package_type', label: 'Package Type' },
  //       { key: 'duration', label: 'Duration' },
  //       { key: 'accommodation', label: 'Accommodation' },
  //       { key: 'meals', label: 'Meals' },
  //       { key: 'transport', label: 'Transport' },
  //       { key: 'guide', label: 'Guide' },
  //       { key: 'mrp', label: 'MRP', type: 'price' },
  //       { key: 'selling_price', label: 'Selling Price', type: 'price' }
  //     ]
  //   },
  //    specifications: [
  //     { key: 'destination', label: 'Destination', type: 'text', required: true },
  //     { key: 'duration', label: 'Duration (days)', type: 'number', required: true },
  //     { key: 'package_type', label: 'Package Type', type: 'select', options: ['Standard', 'Premium', 'Luxury'], required: false },
  //     { key: 'accommodation', label: 'Accommodation', type: 'text', required: false },
  //     { key: 'meals', label: 'Meals', type: 'select', options: ['None', 'Breakfast', 'Half Board', 'Full Board'], required: false },
  //     { key: 'transport', label: 'Transport', type: 'text', required: false },
  //     { key: 'guide', label: 'Guide', type: 'select', options: ['Included', 'Optional', 'Not Included'], required: false },
  //     { key: 'activities', label: 'Activities', type: 'textarea', required: false },
  //   ]
  // },
  'travel': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: false,
      tax: true,
      variants: false,
      medicine: false,
      service: true,
      image: true,
      description: true,
      status: true,
      addItem: false,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false,
      specifications: true
    },

    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id",
        "sku"
      ],

      category: [
        "category_id",
        "subcategory_id"
      ],

      pricing: [
        "purchase_price",
        "selling_price",
        "mrp"
      ],

      tax: [
        "gst_percentage"
      ],

      service: [
        "service_type",
        "service_duration"
      ]
    },

    variant_fields: {
      required: [],
      optional: []
    },

    specifications: [
      { key: "destination", label: "Destination" },
      { key: "departure_city", label: "Departure City" },
      { key: "duration", label: "Duration" },
      { key: "transport_mode", label: "Transport Mode" },
      { key: "hotel_category", label: "Hotel Category" },
      { key: "meal_plan", label: "Meal Plan" },
      { key: "group_size", label: "Group Size" },
      { key: "visa_required", label: "Visa Required" },
      { key: "travel_insurance", label: "Travel Insurance" },
      { key: "booking_type", label: "Booking Type" }
    ],
    table: {
      columns: [
        { key: "product_name", label: "Package" },
        { key: "destination", label: "Destination" },
        { key: "duration", label: "Duration" },
        { key: "transport_mode", label: "Transport" },
        { key: "selling_price", label: "Price" },
        { key: "status", label: "Status" }
      ]
    }
  },
'tour-operator': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'tour_type', label: 'Tour Type', type: 'text' },
    { key: 'destination', label: 'Destination', type: 'text' },
    { key: 'duration', label: 'Duration', type: 'text' },
    { key: 'itinerary', label: 'Itinerary', type: 'textarea' },
    { key: 'guide', label: 'Guide', type: 'select', options: ['Included', 'Optional', 'Not Included'] },
    { key: 'group_size_ids', label: 'Group Size', type: 'number' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Tour Name" },
      { key: "brand_id", label: "Brand" },
      { key: "tour_type", label: "Type" },
      { key: "destination", label: "Destination" },
      { key: "duration", label: "Duration" },
      { key: "group_size_ids", label: "Group Size" },
      { key: "guide", label: "Guide" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

  'visa-services': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'visa_type', label: 'Visa Type', type: 'text' },
    { key: 'country', label: 'Country', type: 'text' },
    { key: 'processing_time', label: 'Processing Time', type: 'text' },
    { key: 'requirements', label: 'Requirements', type: 'textarea' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "visa_type", label: "Visa Type" },
      { key: "country", label: "Country" },
      { key: "processing_time", label: "Processing Time" },
      { key: "requirements", label: "Requirements" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

'ticket-booking': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'travel_type', label: 'Travel Type', type: 'text' },
    { key: 'route', label: 'Route', type: 'text' },
    { key: 'airline', label: 'Airline', type: 'text' },
    { key: 'class', label: 'Class', type: 'select', options: ['Economy', 'Business', 'First'] },
    { key: 'flexibility', label: 'Flexibility', type: 'text' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Ticket Service" },
      { key: "brand_id", label: "Brand" },
      { key: "travel_type", label: "Type" },
      { key: "route", label: "Route" },
      { key: "airline", label: "Airline" },
      { key: "class", label: "Class" },
      { key: "flexibility", label: "Flexibility" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

'advertising': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: true,
    subscription: false,
    property: false,
    specifications: false  // ✅ KEEP AS IS (No specifications needed)
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ MOVE service fields HERE
      "service_type",
      "service_duration",
      "ad_type",
      "platform",
      "reach",
      "duration",
      "deliverables"
    ]
  },
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "ad_type", label: "Ad Type" },
      { key: "platform", label: "Platform" },
      { key: "reach", label: "Reach" },
      { key: "duration", label: "Duration" },
      { key: "deliverables", label: "Deliverables" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

 'digital-marketing': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    specifications: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: true,
    subscription: false,
    property: false
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ MOVE service fields HERE
      "service_type",
      "service_duration",
      "platform",
      "duration",
      "reach",
      "deliverables"
    ]
  },
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "service_type", label: "Type" },
      { key: "platform", label: "Platform" },
      { key: "reach", label: "Reach" },
      { key: "duration", label: "Duration" },
      { key: "deliverables", label: "Deliverables" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

'event-management': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration",
      "event_type",
      "event_duration",
      "capacity",
      "services_included"
    ]
  },
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "event_type", label: "Event Type" },
      { key: "event_duration", label: "Duration" },
      { key: "capacity", label: "Capacity" },
      { key: "services_included", label: "Services" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

 'photography': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: true,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'duration', label: 'Duration', type: 'text' },
    { key: 'style', label: 'Style', type: 'text' },
    { key: 'deliverables', label: 'Deliverables', type: 'textarea' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "service_type", label: "Type" },
      { key: "duration", label: "Duration" },
      { key: "style", label: "Style" },
      { key: "deliverables", label: "Deliverables" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

'video-production': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: true,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'video_type', label: 'Video Type', type: 'text' },
    { key: 'duration', label: 'Duration', type: 'text' },
    { key: 'quality', label: 'Quality', type: 'select', options: ['HD', 'Full HD', '4K'] },
    { key: 'deliverables', label: 'Deliverables', type: 'textarea' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "video_type", label: "Video Type" },
      { key: "duration", label: "Duration" },
      { key: "quality", label: "Quality" },
      { key: "deliverables", label: "Deliverables" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

  // ==================== CATEGORY 17: LEGAL ====================
 'law-firm': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'expertise_area', label: 'Expertise Area', type: 'text' },
    { key: 'qualification', label: 'Qualification', type: 'text' },
    { key: 'experience_years', label: 'Experience (Years)', type: 'number' },
    { key: 'deliverables', label: 'Deliverables', type: 'textarea' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "service_type", label: "Type" },
      { key: "expertise_area", label: "Expertise" },
      { key: "qualification", label: "Qualification" },
      { key: "experience_years", label: "Experience" },
      { key: "deliverables", label: "Deliverables" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

 'advocate': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'expertise_area', label: 'Expertise Area', type: 'text' },
    { key: 'qualification', label: 'Qualification', type: 'text' },
    { key: 'experience_years', label: 'Experience (Years)', type: 'number' },
    { key: 'deliverables', label: 'Deliverables', type: 'textarea' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "expertise_area", label: "Expertise" },
      { key: "qualification", label: "Qualification" },
      { key: "experience_years", label: "Experience" },
      { key: "deliverables", label: "Deliverables" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

 'notary': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'notary_type', label: 'Notary Type', type: 'text' },
    { key: 'deliverables', label: 'Deliverables', type: 'textarea' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "service_type", label: "Type" },
      { key: "notary_type", label: "Notary Type" },
      { key: "deliverables", label: "Deliverables" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

 'legal-consultant': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD brand_id
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD category fields
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD service fields
      "service_type",
      "service_duration"
    ]
  },
  specifications: [  // ✅ MOVE EXTRA FIELDS HERE
    { key: 'expertise_area', label: 'Expertise Area', type: 'text' },
    { key: 'qualification', label: 'Qualification', type: 'text' },
    { key: 'experience_years', label: 'Experience (Years)', type: 'number' },
    { key: 'deliverables', label: 'Deliverables', type: 'textarea' },
  ],
  variant_fields: { required: [], optional: [] },
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "expertise_area", label: "Expertise" },
      { key: "qualification", label: "Qualification" },
      { key: "experience_years", label: "Experience" },
      { key: "deliverables", label: "Deliverables" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

  // ==================== CATEGORY 18: GOVERNMENT ====================
'government-office': {
  components: {
    basic: true,
    category: true,
    pricing: true,
    inventory: false,
    tax: true,
    variants: false,
    medicine: false,
    service: true,
    image: true,
    description: true,
    status: true,
    addItem: true,
    appointment: false,
    food: false,
    digital: false,
    subscription: false,
    property: false,
    specifications: true  // ✅ ADD THIS
  },
  fields: {
    basic: [
      "user_id",
      "product_name",
      "brand_id"  // ✅ ADD THIS
    ],
    category: [
      "category_id",
      "subcategory_id"  // ✅ ADD THIS
    ],
    pricing: [
      "selling_price",
      "mrp"
    ],
    tax: [
      "gst_percentage",
      "hsn_code"
    ],
    service: [  // ✅ ADD THIS
      "service_type",
      "service_duration",
      "department",
      "processing_time",
      "requirements"
    ]
  },
  variant_fields: {
    required: [],
    optional: []
  },
  specifications: [  // ✅ ADD THIS
    { key: 'service_type', label: 'Service Type', type: 'text' },
    { key: 'department', label: 'Department', type: 'text' },
    { key: 'processing_time', label: 'Processing Time', type: 'text' },
    { key: 'requirements', label: 'Requirements', type: 'textarea' },
    { key: 'service_duration', label: 'Service Duration', type: 'text' }
  ],
  table: {
    columns: [
      { key: "product_name", label: "Service Name" },
      { key: "brand_id", label: "Brand" },
      { key: "service_type", label: "Type" },
      { key: "department", label: "Department" },
      { key: "processing_time", label: "Processing Time" },
      { key: "requirements", label: "Requirements" },
      { key: "mrp", label: "MRP", type: "price" },
      { key: "selling_price", label: "Selling Price", type: "price" }
    ]
  }
},

  // ==================== CATEGORY: ENERGY & UTILITIES ====================

  'solar': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: true,
      specifications:true,
      tax: true,
      variants: true,
      medicine: false,
      service: true,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id",
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "purchase_price",
        "selling_price",
        "mrp"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ],
      service: [
        "service_type",
        "service_duration",
        "installation_type"
      ]
    },
    variant_fields: {
      required: ['sku', 'wattage', 'price', 'stock'],
      optional: ['barcode', 'model', 'efficiency', 'warranty']
    },
    table: {
      columns: [
        { key: "product_name", label: "Product Name" },
        { key: "brand_id", label: "Brand" },
        { key: "model", label: "Model" },
        { key: "wattage", label: "Wattage (kW)" },
        { key: "efficiency", label: "Efficiency" },
        { key: "warranty", label: "Warranty" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    },
    specifications: [
      { key: 'brand_id', label: 'Brand', type: 'select', required: true },
      { key: 'model', label: 'Model', type: 'text', required: true },
      { key: 'wattage', label: 'Wattage (kW)', type: 'number', required: true },
      { key: 'efficiency', label: 'Efficiency (%)', type: 'number', required: false },
      { key: 'warranty', label: 'Warranty (Years)', type: 'number', required: false },
      { key: 'certifications', label: 'Certifications', type: 'text', required: false },
      { key: 'installation_type', label: 'Installation Type', type: 'select', options: ['Roof-top', 'Ground-mounted', 'Hybrid'], required: false },
    ]
  },

  'wind': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: true,
      specifications:true,
      tax: true,
      variants: true,
      medicine: false,
      service: true,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id",
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "purchase_price",
        "selling_price",
        "mrp"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ],
      service: [
        "service_type",
        "service_duration",
        "installation_type",
        "maintenance_contract"
      ]
    },
    variant_fields: {
      required: ['sku', 'power_output', 'price', 'stock'],
      optional: ['barcode', 'model', 'rotor_diameter', 'hub_height', 'warranty']
    },
    table: {
      columns: [
        { key: "product_name", label: "Product Name" },
        { key: "brand_id", label: "Brand" },
        { key: "model", label: "Model" },
        { key: "power_output", label: "Power (MW)" },
        { key: "rotor_diameter", label: "Rotor (m)" },
        { key: "hub_height", label: "Hub Height (m)" },
        { key: "warranty", label: "Warranty" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    },
    specifications: [
      { key: 'model', label: 'Model', type: 'text', required: true },
      { key: 'power_output', label: 'Power Output (MW)', type: 'number', required: true },
      { key: 'rotor_diameter', label: 'Rotor Diameter (m)', type: 'number', required: false },
      { key: 'hub_height', label: 'Hub Height (m)', type: 'number', required: false },
      { key: 'warranty', label: 'Warranty (Years)', type: 'number', required: false },
      { key: 'installation_type', label: 'Installation Type', type: 'text', required: false },
      { key: 'maintenance_contract', label: 'Maintenance Contract', type: 'select', options: ['Yes', 'No'], required: false },
    ]
  },

  'electrical-contractor': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      tax: true,
      variants: false,
      medicine: false,
      service: true,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id",
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "selling_price",
        "mrp"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      service: [
        "service_type",
        "service_duration",
        "installation_type",
        "emergency"
      ]
    },
    variant_fields: {
      required: [],
      optional: []
    },
    table: {
      columns: [
        { key: "product_name", label: "Service Name" },
        { key: "service_type", label: "Type" },
        { key: "project_type", label: "Project Type" },
        { key: "voltage", label: "Voltage" },
        { key: "panel_type", label: "Panel Type" },
        { key: "certifications", label: "Certifications" },
        { key: "warranty", label: "Warranty" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" }
      ]
    },
    specifications: [
      { key: 'service_type', label: 'Service Type', type: 'select', options: ['Residential', 'Commercial', 'Industrial'], required: true },
      { key: 'project_type', label: 'Project Type', type: 'text', required: false },
      { key: 'voltage', label: 'Voltage (V)', type: 'text', required: false },
      { key: 'panel_type', label: 'Panel Type', type: 'text', required: false },
      { key: 'emergency', label: 'Emergency Service', type: 'select', options: ['Yes', 'No'], required: false },
      { key: 'certifications', label: 'Certifications', type: 'text', required: false },
    ]
  },

  'oil-gas': {
    components: {
      basic: true,
      category: true,
      pricing: true,
      inventory: true,
      tax: true,
      variants: true,
      medicine: false,
      service: true,
      image: true,
      description: true,
      status: true,
      addItem: true,
      appointment: false,
      food: false,
      digital: false,
      subscription: false,
      property: false
    },
    fields: {
      basic: [
        "user_id",
        "product_name",
        "brand_id",
      ],
      category: [
        "category_id",
        "subcategory_id"
      ],
      pricing: [
        "purchase_price",
        "selling_price",
        "mrp"
      ],
      tax: [
        "gst_percentage",
        "hsn_code"
      ],
      inventory: [
        "unit_id",
        "min_stock_level",
        "reorder_level"
      ],
      service: [
        "service_type",
        "service_duration",
        "installation_type",
        "maintenance_contract"
      ]
    },
    variant_fields: {
      required: ['sku', 'material', 'pipe_size', 'price', 'stock'],
      optional: ['barcode', 'model', 'pressure_rating', 'temperature_rating', 'warranty']
    },
    table: {
      columns: [
        { key: "product_name", label: "Product Name" },
        { key: "brand_id", label: "Brand" },
        { key: "model", label: "Model" },
        { key: "material", label: "Material" },
        { key: "pipe_size", label: "Pipe Size" },
        { key: "pressure_rating", label: "Pressure" },
        { key: "temperature_rating", label: "Temperature" },
        { key: "certifications", label: "Certifications" },
        { key: "mrp", label: "MRP", type: "price" },
        { key: "selling_price", label: "Selling Price", type: "price" },
        { key: "stock", label: "Stock" }
      ]
    },
    specifications: [
      { key: 'brand_id', label: 'Brand', type: 'select', required: true },
      { key: 'model', label: 'Model', type: 'text', required: true },
      { key: 'material', label: 'Material', type: 'select', options: ['Steel', 'Stainless Steel', 'PVC', 'Copper', 'Brass'], required: true },
      { key: 'pipe_size', label: 'Pipe Size (inch)', type: 'number', required: true },
      { key: 'pressure_rating', label: 'Pressure Rating (PSI)', type: 'number', required: false },
      { key: 'temperature_rating', label: 'Temperature Rating (°C)', type: 'number', required: false },
      { key: 'certifications', label: 'Certifications', type: 'text', required: false },
      { key: 'installation_type', label: 'Installation Type', type: 'text', required: false },
      { key: 'maintenance_contract', label: 'Maintenance Contract', type: 'select', options: ['Yes', 'No'], required: false },
    ]
  },

};